<script setup lang="ts">
import { SIDEBAR_IDS } from '@design-system/data/sidebarIds'
import type { ProductCareSideSlideProps } from '@design-system/components/Pdp/EcommerceBlock/PdpEcommerceBlockProductCareSideSlide.props'

defineProps<ProductCareSideSlideProps>()

const formatComposition = (composition: string) => {
  if (!composition) return ''

  return composition
    .split(';')
    .map(part => part.trim())
    .filter(part => part.length > 0)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join('<br>')
}
</script>

<template>
  <OrganismsSidebarSlide
    :id="SIDEBAR_IDS.pdpEcommerceBlockProductCareSideSlide"
    :header-props="{ titleText: $ts('pdp.productCare') }"
  >
    <template #body>
      <div>
        <p class="text-light-6 mb-10">{{ productCare.description }}</p>
        <!-- COMPOSITION PRODUCT -->
        <div v-if="productComposition" class="gap-xxs mb-10 flex flex-col">
          <h3 class="text-medium-6">
            {{
              $ts(
                'pdp.productDetails.informationSection.productCare.productComposition'
              )
            }}
          </h3>
          <div
            class="text-light-6"
            v-html="formatComposition(productComposition)"
          ></div>
        </div>
        <h3 class="text-medium-6">{{ productCare.title }}</h3>
        <div class="mt-4 space-y-4">
          <div v-for="(i, idx) in productCare.items" :key="idx">
            <div class="flex items-center gap-4">
              <div class="h-6 w-6">
                <NuxtPicture
                  :src="i.image ?? ''"
                  class="object-contain"
                  provider="cloudinary"
                  sizes="sm:100vw md:50vw lg:33vw"
                  alt=""
                />
              </div>
              <p class="text-medium-6">{{ i.shortDescription }}</p>
            </div>
            <p class="text-light-6 mb-9 mt-1">
              {{ i.longDescription }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </OrganismsSidebarSlide>
</template>
